// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { GetSubtenantsData, GetSubtenantsResponse, CreateSubtenantData, CreateSubtenantResponse, GetSubtenantByIdData, GetSubtenantByIdResponse, UpdateSubtenantData, UpdateSubtenantResponse, DeleteSubtenantData, DeleteSubtenantResponse, GetSubtenantMembersData, GetSubtenantMembersResponse, UpdateSubtenantMembershipData, UpdateSubtenantMembershipResponse, SignInData, GenerateTokenData, GenerateTokenResponse, CreateApiTokenData2, CreateApiTokenResponse2, GetApiTokensData, GetApiTokensResponse, RevokeApiTokenData2, RevokeApiTokenResponse2, GetApiTokenData, GetApiTokenResponse, GetAvailablePermissionsData, GetAvailablePermissionsResponse, GetTenantsData, GetTenantsResponse, CreateTenantData, CreateTenantResponse, GetTenantByIdData, GetTenantByIdResponse, UpdateTenantData, UpdateTenantResponse, GetSystemInfoResponse, GetJobsData, GetJobsResponse, GetJobData, GetJobResponse, UpdateJobData, UpdateJobResponse, GetJobNodesData, GetJobNodesResponse, GetJobNotificationsData, GetJobNotificationsResponse, DismissJobNotificationsData, DismissJobNotificationsResponse2, GetNodesData, GetNodesResponse, GetNodeByIdData, GetNodeByIdResponse, UpdateNodeData, UpdateNodeResponse, ArchiveNodeData, ArchiveNodeResponse, ChangeNodeOperationalStateData, ChangeNodeOperationalStateResponse, ChangeNodesOperationalStateData, ChangeNodesOperationalStateResponse, BulkArchiveNodesData, BulkArchiveNodesResponse, UpdateBaselineData, UpdateBaselineResponse2, EnableMaintenanceModeData, EnableMaintenanceModeResponse, BulkEnableMaintenanceModeData, BulkEnableMaintenanceModeResponse, AddNodeTagData, AddNodeTagResponse, RemoveNodeTagData, RemoveNodeTagResponse, GetNodeConfigHistoryData, GetNodeConfigHistoryResponse, BulkAssignConfigsData, BulkAssignConfigsResponse, GetNodesPreviousConfigData, GetNodesPreviousConfigResponse, GetTelemetryByNodeData, GetTelemetryByNodeResponse, GetTelemetryByNodeMimicIdData, GetTelemetryByNodeMimicIdResponse, ClearTelemetryData, ClearTelemetryResponse2, GetNodeTelemetryHistogramData, GetNodeTelemetryHistogramResponse, GetNodeTelemetryGroupedEventsData, GetNodeTelemetryGroupedEventsResponse, GetNodeTelemetryEventStreamData, GetNodeTelemetryEventStreamResponse, GetNodeTelemetryOperationNamesData, GetNodeTelemetryOperationNamesResponse, GetNodeResourceUtilizationData, GetNodeResourceUtilizationResponse, GetUsersData, GetUsersResponse, CreateUserData, CreateUserResponse, GetUserProfileResponse, GetUserByIdData, GetUserByIdResponse, UpdateUserData, UpdateUserResponse, GetUserSubtenantsData, GetUserSubtenantsResponse, UpdateUserSubtenantsData, UpdateUserSubtenantsResponse, GetTagsData, GetTagsResponse, CreateTagData, CreateTagResponse, GetTagByIdData, GetTagByIdResponse, UpdateTagData, UpdateTagResponse, DeleteTagData, DeleteTagResponse, UploadNodeConfigData, UploadNodeConfigResponse, GetConfigsData, GetConfigsResponse, UploadConfigRevisionData, UploadConfigRevisionResponse, BuildNewRevisionWithFeaturesData, BuildNewRevisionWithFeaturesResponse, AssignNodeConfigData, AssignNodeConfigResponse, UpdateNodeConfigData, UpdateNodeConfigResponse, GetConfigData, GetConfigResponse, ArchiveNodeConfigData, ArchiveNodeConfigResponse, BulkArchiveNodeConfigsData, BulkArchiveNodeConfigsResponse, UnarchiveNodeConfigData, UnarchiveNodeConfigResponse, GetConfigRevisionsData, GetConfigRevisionsResponse, GetConfigRevisionData, GetConfigRevisionResponse, CreateAuditConfigData, CreateAuditConfigResponse2, CancelScheduledAssignmentData, CancelScheduledAssignmentResponse2, GetLifecycleEventsByNodeData, GetLifecycleEventsByNodeResponse, GetTelemetryByTypeData, GetTelemetryByTypeResponse, GetTenantTelemetryHistogramData, GetTenantTelemetryHistogramResponse, GetTenantTelemetryGroupedEventsData, GetTenantTelemetryGroupedEventsResponse, GetTenantTelemetryEventStreamData, GetTenantTelemetryEventStreamResponse, GetTenantTelemetryOperationNamesData, GetTenantTelemetryOperationNamesResponse, GetTenantTelemetryNodesData, GetTenantTelemetryNodesResponse, GetTenantTelemetryBlobFieldsData, GetTenantTelemetryBlobFieldsResponse, GetTenantTelemetryEventData, GetTenantTelemetryEventResponse, GetTenantActivityData, GetTenantActivityResponse, GetReleasesData, GetReleasesResponse, GetReleaseData, GetReleaseResponse, UpdateReleaseData, UpdateReleaseResponse, PublishReleaseData, PublishReleaseResponse2, RevokeReleaseData, RevokeReleaseResponse2, GetTenantReleasesData, GetTenantReleasesResponse, GetTenantReleaseData, GetTenantReleaseResponse, DownloadTenantReleaseData, DownloadTenantReleaseResponse, GetNotificationsData, GetNotificationsResponse, CliDownloadData, CliDownloadResponse2, CliVersionData, CliVersionResponse2, RotateNodeCredentialsData, RotateNodeCredentialsResponse, CreateProvisioningCredentialsData, CreateProvisioningCredentialsResponse2, PatchProvisioningCredentialsData, PatchProvisioningCredentialsResponse, ListAlertConfigsData, ListAlertConfigsResponse, CreateAlertConfigData, CreateAlertConfigResponse, GetAlertConfigByIdData, GetAlertConfigByIdResponse, UpdateAlertConfigData, UpdateAlertConfigResponse, DeleteAlertData, DeleteAlertResponse, ListAlertResponsesData, ListAlertResponsesResponse2, TestAlertData2, TestAlertResponse2, GetNodeGroupsData, GetNodeGroupsResponse, CreateNodeGroupData, CreateNodeGroupResponse, GetNodeGroupByIdData, GetNodeGroupByIdResponse, UpdateNodeGroupData, UpdateNodeGroupResponse, DeleteNodeGroupData, DeleteNodeGroupResponse, AddNodesToGroupData, AddNodesToGroupResponse, RemoveNodesFromGroupData, RemoveNodesFromGroupResponse, AssignConfigToGroupData, AssignConfigToGroupResponse2, GetInstallerTokensData, GetInstallerTokensResponse, CreateInstallerTokenData2, CreateInstallerTokenResponse2, GetInstallerTokenData, GetInstallerTokenResponse, RevokeInstallerTokenData2, RevokeInstallerTokenResponse2, CreateOauthClientData, CreateOauthClientResponse2, CreateOauthClientsData, CreateOauthClientsResponse, GetOauthClientData, GetOauthClientResponse, UpdateOauthClientData, UpdateOauthClientResponse, DeleteOauthClientData, DeleteOauthClientResponse, OauthAuthorizeData, OauthAuthorizeResponse, OauthTokenData, OauthTokenResponse, OauthUserinfoResponse, GetOpenidConfigurationResponse, GetNodeReleasesData, GetNodeReleasesResponse, GetNodeReleaseData, GetNodeReleaseResponse, GetNodeFeaturesData, GetNodeFeaturesResponse, GetUserActivityData, GetUserActivityResponse, GetActorRecentActivityData, GetActorRecentActivityResponse, CreateAdminOauthClientData, CreateAdminOauthClientResponse, ListAdminOauthClientsData, ListAdminOauthClientsResponse, GetAdminOauthClientData, GetAdminOauthClientResponse, UpdateAdminOauthClientData, UpdateAdminOauthClientResponse, DeleteAdminOauthClientData, DeleteAdminOauthClientResponse, GetM2mAvailablePermissionsData, GetM2mAvailablePermissionsResponse, GetFeatureFlagsResponse, CreateFeatureFlagData, CreateFeatureFlagResponse, GetFeatureFlagByNameData, GetFeatureFlagByNameResponse, UpdateFeatureFlagData, UpdateFeatureFlagResponse, DeleteFeatureFlagData, DeleteFeatureFlagResponse, EnableFeatureFlagForTenantData, EnableFeatureFlagForTenantResponse, DisableFeatureFlagForTenantData, DisableFeatureFlagForTenantResponse, GetTenantFeatureFlagsData, GetTenantFeatureFlagsResponse } from './types.gen';

export class SubtenantsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all subtenants. Returns a hierarchical view by default, or a flat list when flatten=true is specified.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @param data.flatten
     * @returns SubtenantsResponse Paginated list of subtenants. Returns hierarchical view by default, or flat list when flatten=true.
     * @throws ApiError
     */
    public getSubtenants(data: GetSubtenantsData): CancelablePromise<GetSubtenantsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantID}/subtenants',
            path: {
                tenantID: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort,
                flatten: data.flatten
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Create a new subtenant
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns SubtenantResponse Object with subtenant data.
     * @throws ApiError
     */
    public createSubtenant(data: CreateSubtenantData): CancelablePromise<CreateSubtenantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantID}/subtenants',
            path: {
                tenantID: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get subtenant data by its id
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns SubtenantResponse Object with subtenant data.
     * @throws ApiError
     */
    public getSubtenantById(data: GetSubtenantByIdData): CancelablePromise<GetSubtenantByIdResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantID}/subtenants/{id}',
            path: {
                tenantID: data.tenantId,
                id: data.id
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update a subtenant
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.requestBody Request data
     * @returns SubtenantResponse Object with subtenant data.
     * @throws ApiError
     */
    public updateSubtenant(data: UpdateSubtenantData): CancelablePromise<UpdateSubtenantResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantID}/subtenants/{id}',
            path: {
                tenantID: data.tenantId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Delete a subtenant
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns void No content
     * @throws ApiError
     */
    public deleteSubtenant(data: DeleteSubtenantData): CancelablePromise<DeleteSubtenantResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantID}/subtenants/{id}',
            path: {
                tenantID: data.tenantId,
                id: data.id
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get all members of a subtenant
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns SubtenantMembersResponse List of subtenant members.
     * @throws ApiError
     */
    public getSubtenantMembers(data: GetSubtenantMembersData): CancelablePromise<GetSubtenantMembersResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantID}/subtenants/{id}/members',
            path: {
                tenantID: data.tenantId,
                id: data.id
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update a subtenant membership
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.userId
     * @param data.requestBody Request data
     * @returns unknown Membership updated.
     * @throws ApiError
     */
    public updateSubtenantMembership(data: UpdateSubtenantMembershipData): CancelablePromise<UpdateSubtenantMembershipResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantID}/subtenants/{id}/members/{userId}',
            path: {
                tenantID: data.tenantId,
                id: data.id,
                userId: data.userId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
}

export class AuthService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Sign in
     * @param data The data for the request.
     * @param data.email
     * @param data.redirectUrl
     * @throws ApiError
     */
    public signIn(data: SignInData): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/auth/sign-in',
            query: {
                email: data.email,
                redirectUrl: data.redirectUrl
            },
            errors: {
                307: 'Redirect to the sign in URL',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Generates a token for the user.
     * @param data The data for the request.
     * @param data.maxAge
     * @returns TokenResponse Token generated and ready to be used.
     * @throws ApiError
     */
    public generateToken(data: GenerateTokenData = {}): CancelablePromise<GenerateTokenResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/token',
            query: {
                maxAge: data.maxAge
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Sign out
     * @throws ApiError
     */
    public signOut(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/auth/sign-out',
            errors: {
                307: 'Removes session data and redirects to the dashboard',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class ApiTokensService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Create a new API token
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns CreateApiTokenResponse Object with API token data.
     * @throws ApiError
     */
    public createApiToken(data: CreateApiTokenData2): CancelablePromise<CreateApiTokenResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/api-tokens',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get all API tokens
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedApiTokensResponse Paginated list of API tokens.
     * @throws ApiError
     */
    public getApiTokens(data: GetApiTokensData): CancelablePromise<GetApiTokensResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/api-tokens',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Revoke an API token
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.tokenId
     * @returns RevokeApiTokenResponse API token was revoked successfully.
     * @throws ApiError
     */
    public revokeApiToken(data: RevokeApiTokenData2): CancelablePromise<RevokeApiTokenResponse2> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantId}/api-tokens/{tokenId}',
            path: {
                tenantId: data.tenantId,
                tokenId: data.tokenId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get an API token
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.tokenId
     * @returns ApiTokenResponse API token data.
     * @throws ApiError
     */
    public getApiToken(data: GetApiTokenData): CancelablePromise<GetApiTokenResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/api-tokens/{tokenId}',
            path: {
                tenantId: data.tenantId,
                tokenId: data.tokenId
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get all available permissions that can be granted to API tokens
     * @param data The data for the request.
     * @param data.tenantId
     * @returns PermissionsListResponse List of all available permissions.
     * @throws ApiError
     */
    public getAvailablePermissions(data: GetAvailablePermissionsData): CancelablePromise<GetAvailablePermissionsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/api-tokens/permissions',
            path: {
                tenantId: data.tenantId
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
}

export class TenantsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all tenants
     * @param data The data for the request.
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedTenantsResponse Paginated list of tenants.
     * @throws ApiError
     */
    public getTenants(data: GetTenantsData = {}): CancelablePromise<GetTenantsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants',
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Create a new tenant
     * @param data The data for the request.
     * @param data.requestBody Request data
     * @returns TenantResponse Object with tenant data.
     * @throws ApiError
     */
    public createTenant(data: CreateTenantData): CancelablePromise<CreateTenantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get tenant data by its id
     * @param data The data for the request.
     * @param data.id
     * @returns TenantResponse Object with tenant data.
     * @throws ApiError
     */
    public getTenantById(data: GetTenantByIdData): CancelablePromise<GetTenantByIdResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{id}',
            path: {
                id: data.id
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update a tenant
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody Request data
     * @returns TenantResponse Object with tenant data.
     * @throws ApiError
     */
    public updateTenant(data: UpdateTenantData): CancelablePromise<UpdateTenantResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class SystemInfoService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get information about the system
     * @returns SystemInfoResponseSchema Information about the system.
     * @throws ApiError
     */
    public getSystemInfo(): CancelablePromise<GetSystemInfoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/system-info',
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
}

export class JobsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all jobs
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedJobsResponse Paginated list of jobs.
     * @throws ApiError
     */
    public getJobs(data: GetJobsData): CancelablePromise<GetJobsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/jobs',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get a job by ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.jobId
     * @returns JobResponse Job found.
     * @throws ApiError
     */
    public getJob(data: GetJobData): CancelablePromise<GetJobResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/jobs/{jobId}',
            path: {
                tenantId: data.tenantId,
                jobId: data.jobId
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Dismiss a job notification
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.jobId
     * @param data.requestBody Request data
     * @returns JobResponse Job notification dismissed.
     * @throws ApiError
     */
    public updateJob(data: UpdateJobData): CancelablePromise<UpdateJobResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/jobs/{jobId}',
            path: {
                tenantId: data.tenantId,
                jobId: data.jobId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get job nodes by job ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.jobId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedJobNodesResponse Job found.
     * @throws ApiError
     */
    public getJobNodes(data: GetJobNodesData): CancelablePromise<GetJobNodesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/jobs/{jobId}/nodes',
            path: {
                tenantId: data.tenantId,
                jobId: data.jobId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get all job notifications that were not dismissed
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.subtenantId
     * @returns JobNotificationsResponse Summary of job notifications.
     * @throws ApiError
     */
    public getJobNotifications(data: GetJobNotificationsData): CancelablePromise<GetJobNotificationsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/jobs/notifications',
            path: {
                tenantId: data.tenantId
            },
            query: {
                subtenantId: data.subtenantId
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Dismiss job notifications of a type (warning, error, or timeout)
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.status
     * @returns DismissJobNotificationsResponse Job notifications dismissed.
     * @throws ApiError
     */
    public dismissJobNotifications(data: DismissJobNotificationsData): CancelablePromise<DismissJobNotificationsResponse2> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantId}/jobs/notifications/{status}/dismiss',
            path: {
                tenantId: data.tenantId,
                status: data.status
            },
            errors: {
                401: 'Unauthorized',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
}

export class NodesService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all nodes
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodesResponse Paginated list of nodes.
     * @throws ApiError
     */
    public getNodes(data: GetNodesData): CancelablePromise<GetNodesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get node data by its id
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns NodeResponse Object with node data.
     * @throws ApiError
     */
    public getNodeById(data: GetNodeByIdData): CancelablePromise<GetNodeByIdResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{id}',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update a node
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.requestBody Request data
     * @returns NodeResponse Object with node data.
     * @throws ApiError
     */
    public updateNode(data: UpdateNodeData): CancelablePromise<UpdateNodeResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/nodes/{id}',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Archive a node
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns NodeResponse Object with node data.
     * @throws ApiError
     */
    public archiveNode(data: ArchiveNodeData): CancelablePromise<ArchiveNodeResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/archive/nodes/{id}',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Change a nodes operational state
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.requestBody Request data
     * @returns OperationalStateChangeResp Node operational state change
     * @throws ApiError
     */
    public changeNodeOperationalState(data: ChangeNodeOperationalStateData): CancelablePromise<ChangeNodeOperationalStateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/nodes/{id}/operational-state',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Change the operational state of multiple nodes. Validates all nodes first and only proceeds if all pass validation.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns BulkOperationalStateChangeResponse All operational state changes succeeded
     * @throws ApiError
     */
    public changeNodesOperationalState(data: ChangeNodesOperationalStateData): CancelablePromise<ChangeNodesOperationalStateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/nodes/operational-state',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Validation failed for one or more nodes',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Archive multiple nodes. Validates all nodes first and only proceeds if all pass validation. Already-archived nodes pass through without error.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns BulkArchiveResponse All nodes archived
     * @throws ApiError
     */
    public bulkArchiveNodes(data: BulkArchiveNodesData): CancelablePromise<BulkArchiveNodesResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/nodes/archive',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Validation failed for one or more nodes',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update the baseline for a node
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.requestBody Request data
     * @returns UpdateBaselineResponseSchema Node baseline update
     * @throws ApiError
     */
    public updateBaseline(data: UpdateBaselineData): CancelablePromise<UpdateBaselineResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/nodes/{id}/baseline',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get or create a maintenance mode configuration for a node based on its version and operating system. Returns the maintenance config ID without assigning it to the node. Use the assign endpoint to apply the config.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns EnableMaintenanceResponseSchema Maintenance mode enabled successfully
     * @throws ApiError
     */
    public enableMaintenanceMode(data: EnableMaintenanceModeData): CancelablePromise<EnableMaintenanceModeResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/tenants/{tenantId}/nodes/{id}/maintenance',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get or create maintenance configs for multiple nodes. Returns the maintenance config ID for each node.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns BulkMaintenanceResponse Maintenance config ID for each node
     * @throws ApiError
     */
    public bulkEnableMaintenanceMode(data: BulkEnableMaintenanceModeData): CancelablePromise<BulkEnableMaintenanceModeResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/tenants/{tenantId}/nodes/maintenance',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Failed for one or more nodes',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Add a tag to a node
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.tagName
     * @returns NodeTagResponse Object with added node tag association data
     * @throws ApiError
     */
    public addNodeTag(data: AddNodeTagData): CancelablePromise<AddNodeTagResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/nodes/{id}/tags/{tagName}',
            path: {
                tenantId: data.tenantId,
                id: data.id,
                tagName: data.tagName
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Remove a tag from a node
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.tagName
     * @returns NodeTagResponse Object with removed node tag association data
     * @throws ApiError
     */
    public removeNodeTag(data: RemoveNodeTagData): CancelablePromise<RemoveNodeTagResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantId}/nodes/{id}/tags/{tagName}',
            path: {
                tenantId: data.tenantId,
                id: data.id,
                tagName: data.tagName
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get the history of configuration assignments for a node, including all instruction sets that have been applied over time
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodeConfigHistoryResponse Paginated list of config history entries for the node
     * @throws ApiError
     */
    public getNodeConfigHistory(data: GetNodeConfigHistoryData): CancelablePromise<GetNodeConfigHistoryResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/config-history',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Bulk assign configs to nodes. Accepts a list of assignments where each specifies a nodeId, configId, and revisionNumber. Server groups by (configId, revisionNumber) and assigns each group atomically.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns BulkAssignResponse Assignment results grouped by config
     * @throws ApiError
     */
    public bulkAssignConfigs(data: BulkAssignConfigsData): CancelablePromise<BulkAssignConfigsResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/nodes/assign',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Validation or assignment failed',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get the most recent applied standard config for each node. Used when reverting nodes from maintenance mode back to their previous config.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns PreviousConfigResponse Previous standard config for each node
     * @throws ApiError
     */
    public getNodesPreviousConfig(data: GetNodesPreviousConfigData): CancelablePromise<GetNodesPreviousConfigResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/nodes/previous-config',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'One or more nodes not found',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * List aggregated node telemetry grouped by Mimic ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.telemetryType
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodeTelemetry Paginated list of node telemetry grouped by Mimic ID.
     * @throws ApiError
     */
    public getTelemetryByNode(data: GetTelemetryByNodeData): CancelablePromise<GetTelemetryByNodeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/{telemetryType}',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId,
                telemetryType: data.telemetryType
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * List node telemetry events by Mimic ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.telemetryType
     * @param data.mimicId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodeTelemetryEvents Paginated list of node telemetry events.
     * @throws ApiError
     */
    public getTelemetryByNodeMimicId(data: GetTelemetryByNodeMimicIdData): CancelablePromise<GetTelemetryByNodeMimicIdResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/{telemetryType}/{mimicId}',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId,
                telemetryType: data.telemetryType,
                mimicId: data.mimicId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Clear node telemetry by Mimic ID or event ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.telemetryType
     * @param data.requestBody Request data
     * @returns ClearTelemetryResponseSchema Metadata about cleared node telemetry events.
     * @throws ApiError
     */
    public clearTelemetry(data: ClearTelemetryData): CancelablePromise<ClearTelemetryResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/{telemetryType}/clear',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId,
                telemetryType: data.telemetryType
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Time-bucketed event counts grouped by operation_name for a single node. Reads from the events_distributed table (1m/5m buckets) or the events_histogram_distributed materialized view (≥ 15m buckets).
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @param data.operationNames
     * @returns NodeTelemetryHistogramResponse Time-bucketed event counts for the requested node and window.
     * @throws ApiError
     */
    public getNodeTelemetryHistogram(data: GetNodeTelemetryHistogramData): CancelablePromise<GetNodeTelemetryHistogramResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/events/histogram',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until,
                operationNames: data.operationNames
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Per-event-type rows for a single node within a window: count, first_seen, last_seen. Sorted by event_count desc, operation_name asc. Drives the default Grouped view of the dashboard Telemetry tab.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @param data.operationNames
     * @param data.limit
     * @param data.offset
     * @returns NodeTelemetryGroupedResponse Paginated list of per-operation_name event counts for the requested node and window.
     * @throws ApiError
     */
    public getNodeTelemetryGroupedEvents(data: GetNodeTelemetryGroupedEventsData): CancelablePromise<GetNodeTelemetryGroupedEventsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/events/grouped',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until,
                operationNames: data.operationNames,
                limit: data.limit,
                offset: data.offset
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Cursor-paginated raw event stream for a single node within a window. Sorted by event_timestamp DESC, event_id DESC for stable pagination across timestamp ties. nextCursor is null when hasMore is false. Drives the Stream table view of the dashboard Telemetry tab.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @param data.operationNames
     * @param data.limit
     * @param data.cursorTimestamp
     * @param data.cursorEventId
     * @returns NodeTelemetryStreamResponse Cursor-paginated event stream for the requested node and window.
     * @throws ApiError
     */
    public getNodeTelemetryEventStream(data: GetNodeTelemetryEventStreamData): CancelablePromise<GetNodeTelemetryEventStreamResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/events/stream',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until,
                operationNames: data.operationNames,
                limit: data.limit,
                cursorTimestamp: data.cursorTimestamp,
                cursorEventId: data.cursorEventId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Distinct event operation_names + counts for a single node within a window. Drives the operation-name filter dropdown on the dashboard Telemetry tab. Optional `search` is a case-insensitive substring match (ILIKE).
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @param data.operationNames
     * @param data.search
     * @param data.limit
     * @returns NodeTelemetryOperationNamesResponse Distinct operation_names + counts for the requested node and window.
     * @throws ApiError
     */
    public getNodeTelemetryOperationNames(data: GetNodeTelemetryOperationNamesData): CancelablePromise<GetNodeTelemetryOperationNamesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/events/operation-names',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until,
                operationNames: data.operationNames,
                search: data.search,
                limit: data.limit
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Per-minute time series of node resource utilization (user-mode CPU %, memory %, memory bytes used). Reads from the node_resource_utilization_distributed materialized view rollup. cpuUserPct reflects user-mode CPU only — mimic does not currently ship system or idle modes, so this underreports total CPU busy time.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @returns NodeResourceUtilizationResponse Per-minute resource utilization time series for the requested node and window.
     * @throws ApiError
     */
    public getNodeResourceUtilization(data: GetNodeResourceUtilizationData): CancelablePromise<GetNodeResourceUtilizationResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/resource-utilization',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class UsersService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all users
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedUsersResponse Array of users.
     * @throws ApiError
     */
    public getUsers(data: GetUsersData): CancelablePromise<GetUsersResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/users',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Create a new user
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns UserResponse User created.
     * @throws ApiError
     */
    public createUser(data: CreateUserData): CancelablePromise<CreateUserResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/users',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get user profile for the authenticated user (session cookie or Bearer token)
     * @returns UserResponse Object with user data.
     * @throws ApiError
     */
    public getUserProfile(): CancelablePromise<GetUserProfileResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users/profile',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get user data by its id
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns UserResponse Object with user data.
     * @throws ApiError
     */
    public getUserById(data: GetUserByIdData): CancelablePromise<GetUserByIdResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/users/{id}',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update user data
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.requestBody Request data
     * @returns UserResponse User updated.
     * @throws ApiError
     */
    public updateUser(data: UpdateUserData): CancelablePromise<UpdateUserResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/users/{id}',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * List subtenants for a user with their roles
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedUserSubtenant List of subtenants for a user.
     * @throws ApiError
     */
    public getUserSubtenants(data: GetUserSubtenantsData): CancelablePromise<GetUserSubtenantsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/users/{id}/subtenants',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update user subtenant roles
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.requestBody Request data
     * @returns void No content
     * @throws ApiError
     */
    public updateUserSubtenants(data: UpdateUserSubtenantsData): CancelablePromise<UpdateUserSubtenantsResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/users/{id}/subtenants',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class TagsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all tags
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedTagsResponse Paginated list of tags.
     * @throws ApiError
     */
    public getTags(data: GetTagsData): CancelablePromise<GetTagsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantID}/tags',
            path: {
                tenantID: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Create a new tag
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns TagResponse Object with tag data.
     * @throws ApiError
     */
    public createTag(data: CreateTagData): CancelablePromise<CreateTagResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantID}/tags',
            path: {
                tenantID: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get tag data by its id
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns TagResponse Object with tag data.
     * @throws ApiError
     */
    public getTagById(data: GetTagByIdData): CancelablePromise<GetTagByIdResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantID}/tags/{id}',
            path: {
                tenantID: data.tenantId,
                id: data.id
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update a tag
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.requestBody Request data
     * @returns TagResponse Object with tag data.
     * @throws ApiError
     */
    public updateTag(data: UpdateTagData): CancelablePromise<UpdateTagResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantID}/tags/{id}',
            path: {
                tenantID: data.tenantId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Delete a tag
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns void No content
     * @throws ApiError
     */
    public deleteTag(data: DeleteTagData): CancelablePromise<DeleteTagResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantID}/tags/{id}',
            path: {
                tenantID: data.tenantId,
                id: data.id
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class NodeConfigsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Upload new node config files
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.formData Multipart form-data request
     * @returns NodeConfigResponse New node config uploaded.
     * @throws ApiError
     */
    public uploadNodeConfig(data: UploadNodeConfigData): CancelablePromise<UploadNodeConfigResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/config',
            path: {
                tenantId: data.tenantId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * List node configs
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodeConfigsResponse Paginated list of node configs.
     * @throws ApiError
     */
    public getConfigs(data: GetConfigsData): CancelablePromise<GetConfigsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/config',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Upload a new config revision to a node config
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @param data.formData Multipart form-data request
     * @returns ConfigRevisionResponse New config revision uploaded.
     * @throws ApiError
     */
    public uploadConfigRevision(data: UploadConfigRevisionData): CancelablePromise<UploadConfigRevisionResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/config/{configId}/revision',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Create a new revision with different features
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeConfigId
     * @param data.configRevisionNumber
     * @param data.requestBody Request data
     * @returns ConfigRevisionResponse New config revision created.
     * @throws ApiError
     */
    public buildNewRevisionWithFeatures(data: BuildNewRevisionWithFeaturesData): CancelablePromise<BuildNewRevisionWithFeaturesResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/config/{nodeConfigId}/revisions/{configRevisionNumber}/build',
            path: {
                tenantId: data.tenantId,
                nodeConfigId: data.nodeConfigId,
                configRevisionNumber: data.configRevisionNumber
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Assign config to nodes
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @param data.requestBody Request data
     * @returns ConfigAssignmentResponseSchema Config assignment complete.
     * @throws ApiError
     */
    public assignNodeConfig(data: AssignNodeConfigData): CancelablePromise<AssignNodeConfigResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/config/{configId}/assign',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update a node config
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @param data.requestBody Request data
     * @returns NodeConfigResponse Node config updated.
     * @throws ApiError
     */
    public updateNodeConfig(data: UpdateNodeConfigData): CancelablePromise<UpdateNodeConfigResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/config/{configId}',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get node config by Id
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @returns NodeConfigResponse Object of node config data.
     * @throws ApiError
     */
    public getConfig(data: GetConfigData): CancelablePromise<GetConfigResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/config/{configId}',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Archive a node config
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @returns NodeConfigResponse Node config archived.
     * @throws ApiError
     */
    public archiveNodeConfig(data: ArchiveNodeConfigData): CancelablePromise<ArchiveNodeConfigResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/config/{configId}/archive',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Archive multiple node configs. Validates all configs first - invalid configs are reported as errors while valid configs are archived. Already-archived configs pass through without error.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns BulkArchiveConfigResponse Configs archived with results
     * @throws ApiError
     */
    public bulkArchiveNodeConfigs(data: BulkArchiveNodeConfigsData): CancelablePromise<BulkArchiveNodeConfigsResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/config/archive',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Validation failed for all configs',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Unarchive a node config
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @returns NodeConfigResponse Node config unarchived.
     * @throws ApiError
     */
    public unarchiveNodeConfig(data: UnarchiveNodeConfigData): CancelablePromise<UnarchiveNodeConfigResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/config/{configId}/unarchive',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get revisions of a node config
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedConfigRevisionResponse Paginated list of revisions.
     * @throws ApiError
     */
    public getConfigRevisions(data: GetConfigRevisionsData): CancelablePromise<GetConfigRevisionsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/config/{configId}/revisions',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get a specific revision of a node config
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @param data.configRevisionNumber
     * @returns ConfigRevisionResponse Object of config revision data.
     * @throws ApiError
     */
    public getConfigRevision(data: GetConfigRevisionData): CancelablePromise<GetConfigRevisionResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/config/{configId}/revisions/{configRevisionNumber}',
            path: {
                tenantId: data.tenantId,
                configId: data.configId,
                configRevisionNumber: data.configRevisionNumber
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get or create an audit config from a source config. Takes a revision number, transforms ACL rules (DENY_WITH_AUDIT to ALLOW_WITH_AUDIT except for protected resources), and returns the audit config ID. Reuses existing audit configs for the same source config + revision.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @param data.requestBody Request data
     * @returns CreateAuditConfigResponseSchema Audit config created or retrieved successfully
     * @throws ApiError
     */
    public createAuditConfig(data: CreateAuditConfigData): CancelablePromise<CreateAuditConfigResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/config/{configId}/audit',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Cancel a scheduled config assignment
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.jobId
     * @returns CancelScheduledAssignmentResponseSchema Scheduled assignment cancelled successfully
     * @throws ApiError
     */
    public cancelScheduledAssignment(data: CancelScheduledAssignmentData): CancelablePromise<CancelScheduledAssignmentResponse2> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantId}/scheduled-assignments/{jobId}',
            path: {
                tenantId: data.tenantId,
                jobId: data.jobId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class ConfigRevisionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Upload a new config revision to a node config
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @param data.formData Multipart form-data request
     * @returns ConfigRevisionResponse New config revision uploaded.
     * @throws ApiError
     */
    public uploadConfigRevision(data: UploadConfigRevisionData): CancelablePromise<UploadConfigRevisionResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/config/{configId}/revision',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Create a new revision with different features
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeConfigId
     * @param data.configRevisionNumber
     * @param data.requestBody Request data
     * @returns ConfigRevisionResponse New config revision created.
     * @throws ApiError
     */
    public buildNewRevisionWithFeatures(data: BuildNewRevisionWithFeaturesData): CancelablePromise<BuildNewRevisionWithFeaturesResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/config/{nodeConfigId}/revisions/{configRevisionNumber}/build',
            path: {
                tenantId: data.tenantId,
                nodeConfigId: data.nodeConfigId,
                configRevisionNumber: data.configRevisionNumber
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
}

export class ConfigRevisionService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get revisions of a node config
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedConfigRevisionResponse Paginated list of revisions.
     * @throws ApiError
     */
    public getConfigRevisions(data: GetConfigRevisionsData): CancelablePromise<GetConfigRevisionsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/config/{configId}/revisions',
            path: {
                tenantId: data.tenantId,
                configId: data.configId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get a specific revision of a node config
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.configId
     * @param data.configRevisionNumber
     * @returns ConfigRevisionResponse Object of config revision data.
     * @throws ApiError
     */
    public getConfigRevision(data: GetConfigRevisionData): CancelablePromise<GetConfigRevisionResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/config/{configId}/revisions/{configRevisionNumber}',
            path: {
                tenantId: data.tenantId,
                configId: data.configId,
                configRevisionNumber: data.configRevisionNumber
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class NodeLifecycleEventsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * List node lifecycle events
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodeLifecycleEvents Paginated list of node lifecycle events.
     * @throws ApiError
     */
    public getLifecycleEventsByNode(data: GetLifecycleEventsByNodeData): CancelablePromise<GetLifecycleEventsByNodeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/events',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class TelemetryService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * List aggregated node telemetry grouped by node
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.telemetryType
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedActivityTelemetry Paginated list of node telemetry grouped by node.
     * @throws ApiError
     */
    public getTelemetryByType(data: GetTelemetryByTypeData): CancelablePromise<GetTelemetryByTypeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/telemetry/{telemetryType}',
            path: {
                tenantId: data.tenantId,
                telemetryType: data.telemetryType
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * List aggregated node telemetry grouped by Mimic ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.telemetryType
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodeTelemetry Paginated list of node telemetry grouped by Mimic ID.
     * @throws ApiError
     */
    public getTelemetryByNode(data: GetTelemetryByNodeData): CancelablePromise<GetTelemetryByNodeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/{telemetryType}',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId,
                telemetryType: data.telemetryType
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * List node telemetry events by Mimic ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.telemetryType
     * @param data.mimicId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodeTelemetryEvents Paginated list of node telemetry events.
     * @throws ApiError
     */
    public getTelemetryByNodeMimicId(data: GetTelemetryByNodeMimicIdData): CancelablePromise<GetTelemetryByNodeMimicIdResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/{telemetryType}/{mimicId}',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId,
                telemetryType: data.telemetryType,
                mimicId: data.mimicId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Clear node telemetry by Mimic ID or event ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.telemetryType
     * @param data.requestBody Request data
     * @returns ClearTelemetryResponseSchema Metadata about cleared node telemetry events.
     * @throws ApiError
     */
    public clearTelemetry(data: ClearTelemetryData): CancelablePromise<ClearTelemetryResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/{telemetryType}/clear',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId,
                telemetryType: data.telemetryType
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Time-bucketed event counts grouped by operation_name for a single node. Reads from the events_distributed table (1m/5m buckets) or the events_histogram_distributed materialized view (≥ 15m buckets).
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @param data.operationNames
     * @returns NodeTelemetryHistogramResponse Time-bucketed event counts for the requested node and window.
     * @throws ApiError
     */
    public getNodeTelemetryHistogram(data: GetNodeTelemetryHistogramData): CancelablePromise<GetNodeTelemetryHistogramResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/events/histogram',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until,
                operationNames: data.operationNames
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Per-event-type rows for a single node within a window: count, first_seen, last_seen. Sorted by event_count desc, operation_name asc. Drives the default Grouped view of the dashboard Telemetry tab.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @param data.operationNames
     * @param data.limit
     * @param data.offset
     * @returns NodeTelemetryGroupedResponse Paginated list of per-operation_name event counts for the requested node and window.
     * @throws ApiError
     */
    public getNodeTelemetryGroupedEvents(data: GetNodeTelemetryGroupedEventsData): CancelablePromise<GetNodeTelemetryGroupedEventsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/events/grouped',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until,
                operationNames: data.operationNames,
                limit: data.limit,
                offset: data.offset
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Cursor-paginated raw event stream for a single node within a window. Sorted by event_timestamp DESC, event_id DESC for stable pagination across timestamp ties. nextCursor is null when hasMore is false. Drives the Stream table view of the dashboard Telemetry tab.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @param data.operationNames
     * @param data.limit
     * @param data.cursorTimestamp
     * @param data.cursorEventId
     * @returns NodeTelemetryStreamResponse Cursor-paginated event stream for the requested node and window.
     * @throws ApiError
     */
    public getNodeTelemetryEventStream(data: GetNodeTelemetryEventStreamData): CancelablePromise<GetNodeTelemetryEventStreamResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/events/stream',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until,
                operationNames: data.operationNames,
                limit: data.limit,
                cursorTimestamp: data.cursorTimestamp,
                cursorEventId: data.cursorEventId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Distinct event operation_names + counts for a single node within a window. Drives the operation-name filter dropdown on the dashboard Telemetry tab. Optional `search` is a case-insensitive substring match (ILIKE).
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @param data.operationNames
     * @param data.search
     * @param data.limit
     * @returns NodeTelemetryOperationNamesResponse Distinct operation_names + counts for the requested node and window.
     * @throws ApiError
     */
    public getNodeTelemetryOperationNames(data: GetNodeTelemetryOperationNamesData): CancelablePromise<GetNodeTelemetryOperationNamesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/events/operation-names',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until,
                operationNames: data.operationNames,
                search: data.search,
                limit: data.limit
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Per-minute time series of node resource utilization (user-mode CPU %, memory %, memory bytes used). Reads from the node_resource_utilization_distributed materialized view rollup. cpuUserPct reflects user-mode CPU only — mimic does not currently ship system or idle modes, so this underreports total CPU busy time.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @param data.since
     * @param data.until
     * @returns NodeResourceUtilizationResponse Per-minute resource utilization time series for the requested node and window.
     * @throws ApiError
     */
    public getNodeResourceUtilization(data: GetNodeResourceUtilizationData): CancelablePromise<GetNodeResourceUtilizationResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/telemetry/resource-utilization',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            query: {
                since: data.since,
                until: data.until
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Time-bucketed event counts grouped by operation_name across the tenant. Optional nodeIds, operationNames, and blobFields filters narrow the result set; the same filters apply consistently across every panel of the dashboard's standalone Telemetry page. Reads from the events_distributed table (1m/5m buckets, or any bucket when blobFields is set) or the events_histogram_distributed materialized view (>= 15m buckets when blobFields is empty).
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.since
     * @param data.until
     * @param data.nodeIds
     * @param data.operationNames
     * @param data.blobFields
     * @returns TenantTelemetryHistogramResponse Time-bucketed event counts for the requested tenant and window.
     * @throws ApiError
     */
    public getTenantTelemetryHistogram(data: GetTenantTelemetryHistogramData): CancelablePromise<GetTenantTelemetryHistogramResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/telemetry/events/histogram',
            path: {
                tenantId: data.tenantId
            },
            query: {
                since: data.since,
                until: data.until,
                nodeIds: data.nodeIds,
                operationNames: data.operationNames,
                blobFields: data.blobFields
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Aggregated event-count rows for a tenant. groupBy picks the dimension: 'operation' (default) groups by operation_name; 'node' groups by node_id; 'node,operation' groups by both. Sorted by event_count desc, then by the grouped dimension(s) asc on tie. Cursor pagination via limit/offset; hasMore is true when more rows exist beyond limit.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.since
     * @param data.until
     * @param data.nodeIds
     * @param data.operationNames
     * @param data.blobFields
     * @param data.groupBy
     * @param data.limit
     * @param data.offset
     * @returns TenantTelemetryGroupedResponse Paginated aggregated event counts for the requested tenant and window.
     * @throws ApiError
     */
    public getTenantTelemetryGroupedEvents(data: GetTenantTelemetryGroupedEventsData): CancelablePromise<GetTenantTelemetryGroupedEventsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/telemetry/events/grouped',
            path: {
                tenantId: data.tenantId
            },
            query: {
                since: data.since,
                until: data.until,
                nodeIds: data.nodeIds,
                operationNames: data.operationNames,
                blobFields: data.blobFields,
                groupBy: data.groupBy,
                limit: data.limit,
                offset: data.offset
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Cursor-paginated raw event stream across the tenant. Sorted by event_timestamp DESC, event_id DESC for stable pagination across timestamp ties. nextCursor is null when hasMore is false. The summary field is an array of {text, mono} segments derived from event_blob — same shape as the per-node Telemetry tab.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.since
     * @param data.until
     * @param data.nodeIds
     * @param data.operationNames
     * @param data.blobFields
     * @param data.limit
     * @param data.cursorTimestamp
     * @param data.cursorEventId
     * @returns TenantTelemetryStreamResponse Cursor-paginated event stream for the requested tenant and window.
     * @throws ApiError
     */
    public getTenantTelemetryEventStream(data: GetTenantTelemetryEventStreamData): CancelablePromise<GetTenantTelemetryEventStreamResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/telemetry/events/stream',
            path: {
                tenantId: data.tenantId
            },
            query: {
                since: data.since,
                until: data.until,
                nodeIds: data.nodeIds,
                operationNames: data.operationNames,
                blobFields: data.blobFields,
                limit: data.limit,
                cursorTimestamp: data.cursorTimestamp,
                cursorEventId: data.cursorEventId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Distinct event operation_names + counts across the tenant within the current filter window. Drives the Event Type accordion on the standalone Telemetry page. Optional search is a case-insensitive substring match (ILIKE) against operation_name.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.since
     * @param data.until
     * @param data.nodeIds
     * @param data.operationNames
     * @param data.blobFields
     * @param data.search
     * @param data.limit
     * @returns TenantTelemetryOperationNamesResponse Distinct operation_names + counts for the requested tenant and window.
     * @throws ApiError
     */
    public getTenantTelemetryOperationNames(data: GetTenantTelemetryOperationNamesData): CancelablePromise<GetTenantTelemetryOperationNamesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/telemetry/events/operation-names',
            path: {
                tenantId: data.tenantId
            },
            query: {
                since: data.since,
                until: data.until,
                nodeIds: data.nodeIds,
                operationNames: data.operationNames,
                blobFields: data.blobFields,
                search: data.search,
                limit: data.limit
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Nodes that have events in the current filter window, with per-node event counts and the node name (hydrated from Postgres). Drives the Nodes accordion on the standalone Telemetry page. Optional search is a case-insensitive ILIKE substring match against node name. Subtenant access is enforced — callers only see nodes they have access to.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.since
     * @param data.until
     * @param data.nodeIds
     * @param data.operationNames
     * @param data.blobFields
     * @param data.search
     * @param data.limit
     * @returns TenantTelemetryNodesResponse Per-node event counts (with name) for the requested tenant and window.
     * @throws ApiError
     */
    public getTenantTelemetryNodes(data: GetTenantTelemetryNodesData): CancelablePromise<GetTenantTelemetryNodesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/telemetry/events/nodes',
            path: {
                tenantId: data.tenantId
            },
            query: {
                since: data.since,
                until: data.until,
                nodeIds: data.nodeIds,
                operationNames: data.operationNames,
                blobFields: data.blobFields,
                search: data.search,
                limit: data.limit
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Distinct top-level keys present in event_blob (sampled) with per-key counts. Drives the Blob Fields accordion on the standalone Telemetry page. Sampling is required because scanning the full event set for JSON keys is expensive on dense tenants — default 1000 recent events, max 10000. Returns up to 50 most-frequent keys.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.since
     * @param data.until
     * @param data.nodeIds
     * @param data.operationNames
     * @param data.blobFields
     * @param data.sampleLimit
     * @returns TenantTelemetryBlobFieldsResponse Distinct event_blob top-level keys + per-key counts (sampled).
     * @throws ApiError
     */
    public getTenantTelemetryBlobFields(data: GetTenantTelemetryBlobFieldsData): CancelablePromise<GetTenantTelemetryBlobFieldsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/telemetry/events/blob-fields',
            path: {
                tenantId: data.tenantId
            },
            query: {
                since: data.since,
                until: data.until,
                nodeIds: data.nodeIds,
                operationNames: data.operationNames,
                blobFields: data.blobFields,
                sampleLimit: data.sampleLimit
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Single event with the full event_blob for the detail drawer. ts is required (the dashboard already has the timestamp from the row the user clicked) so ClickHouse can do a sparse-index seek instead of a partition scan. Subtenant access is enforced — events on inaccessible nodes return 404 (never 403, to avoid leaking event existence).
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.eventId
     * @param data.ts
     * @returns TenantTelemetryEventResponse A single event including the full event_blob string.
     * @throws ApiError
     */
    public getTenantTelemetryEvent(data: GetTenantTelemetryEventData): CancelablePromise<GetTenantTelemetryEventResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/telemetry/events/{eventId}',
            path: {
                tenantId: data.tenantId,
                eventId: data.eventId
            },
            query: {
                ts: data.ts
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * List per-node event counts for a tenant within a time window. Returns nodes ordered by event count desc.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.section
     * @param data.window
     * @param data.offset
     * @param data.limit
     * @param data.since
     * @param data.until
     * @param data.subtenantId
     * @returns TelemetryActivityResponse Per-node event counts and last-seen timestamps for the requested window.
     * @throws ApiError
     */
    public getTenantActivity(data: GetTenantActivityData): CancelablePromise<GetTenantActivityResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/activity',
            path: {
                tenantId: data.tenantId
            },
            query: {
                section: data.section,
                window: data.window,
                offset: data.offset,
                limit: data.limit,
                since: data.since,
                until: data.until,
                subtenantId: data.subtenantId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class ReleasesService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * List releases
     * @param data The data for the request.
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedReleasesResponse Paginated list of releases.
     * @throws ApiError
     */
    public getReleases(data: GetReleasesData = {}): CancelablePromise<GetReleasesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/releases',
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get a release by version
     * @param data The data for the request.
     * @param data.releaseId
     * @returns ReleaseResponseSchema Object with release data.
     * @throws ApiError
     */
    public getRelease(data: GetReleaseData): CancelablePromise<GetReleaseResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/releases/{releaseId}',
            path: {
                releaseId: data.releaseId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update a release
     * @param data The data for the request.
     * @param data.releaseId
     * @param data.requestBody Request data
     * @returns UpdateReleaseResponseSchema Updated release.
     * @throws ApiError
     */
    public updateRelease(data: UpdateReleaseData): CancelablePromise<UpdateReleaseResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/releases/{releaseId}',
            path: {
                releaseId: data.releaseId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Publish a release
     * @param data The data for the request.
     * @param data.releaseId
     * @param data.requestBody Request data
     * @returns PublishReleaseResponseSchema Release published
     * @throws ApiError
     */
    public publishRelease(data: PublishReleaseData): CancelablePromise<PublishReleaseResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/releases/{releaseId}/publish',
            path: {
                releaseId: data.releaseId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Revoke a release
     * @param data The data for the request.
     * @param data.releaseId
     * @param data.requestBody Request data
     * @returns RevokeReleaseResponseSchema Release revoked.
     * @throws ApiError
     */
    public revokeRelease(data: RevokeReleaseData): CancelablePromise<RevokeReleaseResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/releases/{releaseId}/revoke',
            path: {
                releaseId: data.releaseId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class TenantReleasesService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * List releases available to a tenant
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedTenantReleasesResponse Paginated list of tenant releases.
     * @throws ApiError
     */
    public getTenantReleases(data: GetTenantReleasesData): CancelablePromise<GetTenantReleasesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/releases',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get a release by version for a tenant
     * @param data The data for the request.
     * @param data.releaseId
     * @param data.tenantId
     * @returns TenantReleaseResponseSchema Single release for a tenant
     * @throws ApiError
     */
    public getTenantRelease(data: GetTenantReleaseData): CancelablePromise<GetTenantReleaseResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/releases/{releaseId}',
            path: {
                releaseId: data.releaseId,
                tenantId: data.tenantId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get the download URL for a release by version for a tenant
     * @param data The data for the request.
     * @param data.releaseId
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns TenantReleaseDownloadResponse Download URL generated
     * @throws ApiError
     */
    public downloadTenantRelease(data: DownloadTenantReleaseData): CancelablePromise<DownloadTenantReleaseResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/releases/{releaseId}/download',
            path: {
                releaseId: data.releaseId,
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class NotificationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all notifications
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNotificationsResponse Paginated list of notifications.
     * @throws ApiError
     */
    public getNotifications(data: GetNotificationsData): CancelablePromise<GetNotificationsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/notifications',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
}

export class CliService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get a link to download the Mimic CLI
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.archType
     * @param data.osType
     * @returns CliDownloadResponse Object with CLI data.
     * @throws ApiError
     */
    public cliDownload(data: CliDownloadData): CancelablePromise<CliDownloadResponse2> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantID}/cli/download',
            path: {
                tenantID: data.tenantId
            },
            query: {
                archType: data.archType,
                osType: data.osType
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get the latest Mimic CLI semantic version
     * @param data The data for the request.
     * @param data.tenantId
     * @returns CliVersionResponse Object with CLI version data.
     * @throws ApiError
     */
    public cliVersion(data: CliVersionData): CancelablePromise<CliVersionResponse2> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantID}/cli/version',
            path: {
                tenantID: data.tenantId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class NodeCredentialsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Rotate node credentials
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeId
     * @returns CredentialRotationResponseSchema Node credentials rotated
     * @throws ApiError
     */
    public rotateNodeCredentials(data: RotateNodeCredentialsData): CancelablePromise<RotateNodeCredentialsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/nodes/{nodeId}/new-credentials',
            path: {
                tenantId: data.tenantId,
                nodeId: data.nodeId
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class ProvisioningCredentialsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Create a set of provisioning credentials for a tenant
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns CreateProvisioningCredentialsResponse Provisioning credentials created
     * @throws ApiError
     */
    public createProvisioningCredentials(data: CreateProvisioningCredentialsData): CancelablePromise<CreateProvisioningCredentialsResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/provisioning-credentials',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                429: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update provisioning credentials
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.credentialId
     * @param data.requestBody Request data
     * @returns QuotaUpdateResponseSchema Update provisioning credentials
     * @throws ApiError
     */
    public patchProvisioningCredentials(data: PatchProvisioningCredentialsData): CancelablePromise<PatchProvisioningCredentialsResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/provisioning-credentials/{credentialId}',
            path: {
                tenantId: data.tenantId,
                credentialId: data.credentialId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class AlertsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * List alerts
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.sort
     * @returns ListAlertsResponse Listing alert configurations.
     * @throws ApiError
     */
    public listAlertConfigs(data: ListAlertConfigsData): CancelablePromise<ListAlertConfigsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/alerts',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Configure alerts
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns AlertConfigResponse New alert configured.
     * @throws ApiError
     */
    public createAlertConfig(data: CreateAlertConfigData): CancelablePromise<CreateAlertConfigResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/alerts',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get an alert configuration by ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns AlertConfigResponse Alert configuration retrieved.
     * @throws ApiError
     */
    public getAlertConfigById(data: GetAlertConfigByIdData): CancelablePromise<GetAlertConfigByIdResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/alerts/{id}',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update an alert configuration
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.requestBody Request data
     * @returns AlertConfigResponse Alert configuration updated.
     * @throws ApiError
     */
    public updateAlertConfig(data: UpdateAlertConfigData): CancelablePromise<UpdateAlertConfigResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/alerts/{id}',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Delete an alert
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @returns void No content
     * @throws ApiError
     */
    public deleteAlert(data: DeleteAlertData): CancelablePromise<DeleteAlertResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantId}/alerts/{id}',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * List results for an alert configuration
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns ListAlertResponsesResponse Alert responses retrieved successfully
     * @throws ApiError
     */
    public listAlertResponses(data: ListAlertResponsesData): CancelablePromise<ListAlertResponsesResponse2> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/alerts/{id}/responses',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Send a test event to verify configuration
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.id
     * @param data.requestBody Request data
     * @returns TestAlertResponse Test alert queued successfully
     * @throws ApiError
     */
    public testAlert(data: TestAlertData2): CancelablePromise<TestAlertResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/alerts/{id}/test',
            path: {
                tenantId: data.tenantId,
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class NodeGroupsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all node groups
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodeGroupsResponse Paginated list of node groups.
     * @throws ApiError
     */
    public getNodeGroups(data: GetNodeGroupsData): CancelablePromise<GetNodeGroupsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantID}/node-groups',
            path: {
                tenantID: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Create a new node group
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns NodeGroupResponse Node group created.
     * @throws ApiError
     */
    public createNodeGroup(data: CreateNodeGroupData): CancelablePromise<CreateNodeGroupResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantID}/node-groups',
            path: {
                tenantID: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get a single node group by ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeGroupId
     * @returns NodeGroupResponse Node group details.
     * @throws ApiError
     */
    public getNodeGroupById(data: GetNodeGroupByIdData): CancelablePromise<GetNodeGroupByIdResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantID}/node-groups/{nodeGroupId}',
            path: {
                tenantID: data.tenantId,
                nodeGroupId: data.nodeGroupId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update a node group
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeGroupId
     * @param data.requestBody Request data
     * @returns NodeGroupResponse Node group updated.
     * @throws ApiError
     */
    public updateNodeGroup(data: UpdateNodeGroupData): CancelablePromise<UpdateNodeGroupResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantID}/node-groups/{nodeGroupId}',
            path: {
                tenantID: data.tenantId,
                nodeGroupId: data.nodeGroupId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Delete a node group
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeGroupId
     * @returns void No content
     * @throws ApiError
     */
    public deleteNodeGroup(data: DeleteNodeGroupData): CancelablePromise<DeleteNodeGroupResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantID}/node-groups/{nodeGroupId}',
            path: {
                tenantID: data.tenantId,
                nodeGroupId: data.nodeGroupId
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not found',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Add nodes to an existing node group
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeGroupId
     * @param data.requestBody Request data
     * @returns NodeGroupResponse Node group updated with new members.
     * @throws ApiError
     */
    public addNodesToGroup(data: AddNodesToGroupData): CancelablePromise<AddNodesToGroupResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantID}/node-groups/{nodeGroupId}/nodes',
            path: {
                tenantID: data.tenantId,
                nodeGroupId: data.nodeGroupId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Remove nodes from an existing node group
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeGroupId
     * @param data.requestBody Request data
     * @returns void Nodes removed from group.
     * @throws ApiError
     */
    public removeNodesFromGroup(data: RemoveNodesFromGroupData): CancelablePromise<RemoveNodesFromGroupResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantID}/node-groups/{nodeGroupId}/nodes',
            path: {
                tenantID: data.tenantId,
                nodeGroupId: data.nodeGroupId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Assign a config to the node group and apply it to all nodes in the group
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.nodeGroupId
     * @param data.requestBody Request data
     * @returns AssignConfigToGroupResponse Config assigned to node group and applied to all nodes.
     * @throws ApiError
     */
    public assignConfigToGroup(data: AssignConfigToGroupData): CancelablePromise<AssignConfigToGroupResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantID}/node-groups/{nodeGroupId}/assign',
            path: {
                tenantID: data.tenantId,
                nodeGroupId: data.nodeGroupId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class InstallerTokensService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all installer tokens
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedInstallerTokensResponse Paginated list of installer tokens.
     * @throws ApiError
     */
    public getInstallerTokens(data: GetInstallerTokensData): CancelablePromise<GetInstallerTokensResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/installer-tokens',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Create a new installer token. The JWT token is returned only once and must be saved immediately.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns CreateInstallerTokenResponse Token created successfully (includes JWT for one-time display)
     * @throws ApiError
     */
    public createInstallerToken(data: CreateInstallerTokenData2): CancelablePromise<CreateInstallerTokenResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/installer-tokens',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                409: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get a single installer token by ID
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.tokenId
     * @returns InstallerTokenResponse Installer token retrieved successfully.
     * @throws ApiError
     */
    public getInstallerToken(data: GetInstallerTokenData): CancelablePromise<GetInstallerTokenResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/installer-tokens/{tokenId}',
            path: {
                tenantId: data.tenantId,
                tokenId: data.tokenId
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Revoke an installer token. This invalidates and prevents further node installations.
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.tokenId
     * @returns RevokeInstallerTokenResponse Token revoked successfully
     * @throws ApiError
     */
    public revokeInstallerToken(data: RevokeInstallerTokenData2): CancelablePromise<RevokeInstallerTokenResponse2> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantId}/installer-tokens/{tokenId}',
            path: {
                tenantId: data.tenantId,
                tokenId: data.tokenId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class OauthClientsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Create an OAuth Client
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.requestBody Request data
     * @returns CreateOauthClientResponse Created Client with client_id and client_secret
     * @throws ApiError
     */
    public createOauthClient(data: CreateOauthClientData): CancelablePromise<CreateOauthClientResponse2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/tenants/{tenantId}/oauth-clients',
            path: {
                tenantId: data.tenantId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * List OAuth Clients for a Tenant
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedOauthClientsResponseSchema Get Client
     * @throws ApiError
     */
    public createOauthClients(data: CreateOauthClientsData): CancelablePromise<CreateOauthClientsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/oauth-clients',
            path: {
                tenantId: data.tenantId
            },
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get an OAuth Client
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.oauthClientId
     * @returns OauthClientResponse Get Client
     * @throws ApiError
     */
    public getOauthClient(data: GetOauthClientData): CancelablePromise<GetOauthClientResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/oauth-clients/{oauthClientId}',
            path: {
                tenantId: data.tenantId,
                oauthClientId: data.oauthClientId
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update an OAuth Client
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.oauthClientId
     * @param data.requestBody Request data
     * @returns OauthClientResponse Update OAuth Client attributes
     * @throws ApiError
     */
    public updateOauthClient(data: UpdateOauthClientData): CancelablePromise<UpdateOauthClientResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/tenants/{tenantId}/oauth-clients/{oauthClientId}',
            path: {
                tenantId: data.tenantId,
                oauthClientId: data.oauthClientId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Delete an Oauth Client
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.oauthClientId
     * @returns void OAuth Client deleted succesfully
     * @throws ApiError
     */
    public deleteOauthClient(data: DeleteOauthClientData): CancelablePromise<DeleteOauthClientResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/tenants/{tenantId}/oauth-clients/{oauthClientId}',
            path: {
                tenantId: data.tenantId,
                oauthClientId: data.oauthClientId
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class OauthService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Authorize an OAuth request
     * @param data The data for the request.
     * @param data.clientId
     * @param data.responseType
     * @param data.redirectUri
     * @param data.codeChallenge
     * @param data.codeChallengeMethod
     * @param data.scope
     * @param data.responseMode OAuth 2.0 response mode. Supported values: 'query' (default), 'form_post'.
     * @param data.state
     * @param data.nonce
     * @returns unknown Successfully received a code to generate a token
     * @throws ApiError
     */
    public oauthAuthorize(data: OauthAuthorizeData): CancelablePromise<OauthAuthorizeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/oauth/authorize',
            query: {
                client_id: data.clientId,
                scope: data.scope,
                response_type: data.responseType,
                response_mode: data.responseMode,
                redirect_uri: data.redirectUri,
                state: data.state,
                code_challenge: data.codeChallenge,
                nonce: data.nonce,
                code_challenge_method: data.codeChallengeMethod
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get an Oauth Token
     * @param data The data for the request.
     * @param data.requestBody Request data
     * @returns OauthTokenResponseSchema Successfully received a code to generate a token
     * @throws ApiError
     */
    public oauthToken(data: OauthTokenData): CancelablePromise<OauthTokenResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/oauth/token',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get Userinfo from an access token
     * @returns OauthUserinfoResponseSchema Successfully received a code to generate a token
     * @throws ApiError
     */
    public oauthUserinfo(): CancelablePromise<OauthUserinfoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/oauth/userinfo',
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Return openid configuration data
     * @returns DiscoveryResponseSchema Successfully received openid configuration data
     * @throws ApiError
     */
    public getOpenidConfiguration(): CancelablePromise<GetOpenidConfigurationResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/oauth/.well-known/openid-configuration',
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
}

export class NodeReleasesService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * List node releases
     * @param data The data for the request.
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedNodeReleasesResponse Paginated list of node releases.
     * @throws ApiError
     */
    public getNodeReleases(data: GetNodeReleasesData = {}): CancelablePromise<GetNodeReleasesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/node-releases',
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get a node release by ID with scout mode configuration
     * @param data The data for the request.
     * @param data.nodeReleaseId
     * @returns NodeReleaseDetailResponseSchema Object with node release data including scout mode configuration.
     * @throws ApiError
     */
    public getNodeRelease(data: GetNodeReleaseData): CancelablePromise<GetNodeReleaseResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/node-releases/{nodeReleaseId}',
            path: {
                nodeReleaseId: data.nodeReleaseId
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class NodeFeaturesService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * List node features for a specific node version
     * @param data The data for the request.
     * @param data.pre
     * @returns NodeFeatures List of node features availble for the passed in feature
     * @throws ApiError
     */
    public getNodeFeatures(data: GetNodeFeaturesData = {}): CancelablePromise<GetNodeFeaturesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/node-features/{nodeVersion}',
            query: {
                pre: data.pre
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
}

export class ActivityService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get paginated activity logs for all users
     * @param data The data for the request.
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedActivityLogsResponse Paginated list of activity logs.
     * @throws ApiError
     */
    public getUserActivity(data: GetUserActivityData = {}): CancelablePromise<GetUserActivityResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/activity',
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get the most recent activity log for a specific user actor
     * @param data The data for the request.
     * @param data.actorId
     * @returns ActivityLogResponse Most recent activity log for the actor.
     * @throws ApiError
     */
    public getActorRecentActivity(data: GetActorRecentActivityData): CancelablePromise<GetActorRecentActivityResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/activity/{actorId}',
            path: {
                actorId: data.actorId
            },
            errors: {
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
}

export class AdminOauthClientsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Create a new M2M OAuth client
     * @param data The data for the request.
     * @param data.requestBody Request data
     * @returns CreateM2MClientResponse Created M2M client.
     * @throws ApiError
     */
    public createAdminOauthClient(data: CreateAdminOauthClientData): CancelablePromise<CreateAdminOauthClientResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/admin/oauth-clients',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error'
            }
        });
    }
    
    /**
     * List M2M OAuth clients
     * @param data The data for the request.
     * @param data.page
     * @param data.pageSize
     * @param data.filters
     * @param data.sort
     * @returns PaginatedM2MClientsResponseSchema List of M2M OAuth clients.
     * @throws ApiError
     */
    public listAdminOauthClients(data: ListAdminOauthClientsData = {}): CancelablePromise<ListAdminOauthClientsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/oauth-clients',
            query: {
                page: data.page,
                pageSize: data.pageSize,
                filters: data.filters,
                sort: data.sort
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error'
            }
        });
    }
    
    /**
     * Get a M2M OAuth client by ID
     * @param data The data for the request.
     * @param data.clientId
     * @returns M2MClientResponse M2M OAuth client details.
     * @throws ApiError
     */
    public getAdminOauthClient(data: GetAdminOauthClientData): CancelablePromise<GetAdminOauthClientResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/oauth-clients/{clientId}',
            path: {
                clientId: data.clientId
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found'
            }
        });
    }
    
    /**
     * Update an existing M2M OAuth client. Allows changing name and/or allowedScopes. Does not rotate credentials.
     * @param data The data for the request.
     * @param data.clientId
     * @param data.requestBody Request data
     * @returns M2MClientResponse Updated M2M client.
     * @throws ApiError
     */
    public updateAdminOauthClient(data: UpdateAdminOauthClientData): CancelablePromise<UpdateAdminOauthClientResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/admin/oauth-clients/{clientId}',
            path: {
                clientId: data.clientId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found'
            }
        });
    }
    
    /**
     * Delete a M2M OAuth client
     * @param data The data for the request.
     * @param data.clientId
     * @returns void M2M client deleted.
     * @throws ApiError
     */
    public deleteAdminOauthClient(data: DeleteAdminOauthClientData): CancelablePromise<DeleteAdminOauthClientResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/admin/oauth-clients/{clientId}',
            path: {
                clientId: data.clientId
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found'
            }
        });
    }
    
    /**
     * Get all available permissions that can be granted to M2M clients
     * @param data The data for the request.
     * @param data.tenantId
     * @returns PermissionsListResponse List of all available permissions.
     * @throws ApiError
     */
    public getM2mAvailablePermissions(data: GetM2mAvailablePermissionsData): CancelablePromise<GetM2mAvailablePermissionsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/oauth-clients/permissions',
            path: {
                tenantId: data.tenantId
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error'
            }
        });
    }
    
}

export class FeatureFlagsService {
    constructor(public readonly httpRequest: BaseHttpRequest) { }
    
    /**
     * Get all feature flags
     * @returns FeatureFlagsListResponse List of feature flags.
     * @throws ApiError
     */
    public getFeatureFlags(): CancelablePromise<GetFeatureFlagsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/feature-flags',
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Create a new feature flag
     * @param data The data for the request.
     * @param data.requestBody Request data
     * @returns FeatureFlagResponse Created feature flag.
     * @throws ApiError
     */
    public createFeatureFlag(data: CreateFeatureFlagData): CancelablePromise<CreateFeatureFlagResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/admin/feature-flags',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get a feature flag by name
     * @param data The data for the request.
     * @param data.name
     * @returns FeatureFlagResponse Feature flag data.
     * @throws ApiError
     */
    public getFeatureFlagByName(data: GetFeatureFlagByNameData): CancelablePromise<GetFeatureFlagByNameResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/feature-flags/{name}',
            path: {
                name: data.name
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Update a feature flag
     * @param data The data for the request.
     * @param data.name
     * @param data.requestBody Request data
     * @returns FeatureFlagResponse Updated feature flag.
     * @throws ApiError
     */
    public updateFeatureFlag(data: UpdateFeatureFlagData): CancelablePromise<UpdateFeatureFlagResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/admin/feature-flags/{name}',
            path: {
                name: data.name
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Delete a feature flag
     * @param data The data for the request.
     * @param data.name
     * @returns void No content
     * @throws ApiError
     */
    public deleteFeatureFlag(data: DeleteFeatureFlagData): CancelablePromise<DeleteFeatureFlagResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/admin/feature-flags/{name}',
            path: {
                name: data.name
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Enable a feature flag for a specific tenant
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.name
     * @returns FeatureFlagResponse Feature flag enabled for tenant.
     * @throws ApiError
     */
    public enableFeatureFlagForTenant(data: EnableFeatureFlagForTenantData): CancelablePromise<EnableFeatureFlagForTenantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/admin/tenants/{tenantId}/feature-flags/{name}',
            path: {
                tenantId: data.tenantId,
                name: data.name
            },
            errors: {
                400: 'Error',
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Disable a feature flag for a specific tenant
     * @param data The data for the request.
     * @param data.tenantId
     * @param data.name
     * @returns void No content
     * @throws ApiError
     */
    public disableFeatureFlagForTenant(data: DisableFeatureFlagForTenantData): CancelablePromise<DisableFeatureFlagForTenantResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/admin/tenants/{tenantId}/feature-flags/{name}',
            path: {
                tenantId: data.tenantId,
                name: data.name
            },
            errors: {
                401: 'Unauthorized',
                403: 'Error',
                404: 'Not found',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Get feature flags enabled for a tenant
     * @param data The data for the request.
     * @param data.tenantId
     * @returns TenantFeatureFlagsResponse Map of feature flag names to boolean values.
     * @throws ApiError
     */
    public getTenantFeatureFlags(data: GetTenantFeatureFlagsData): CancelablePromise<GetTenantFeatureFlagsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tenants/{tenantId}/feature-flags',
            path: {
                tenantId: data.tenantId
            },
            errors: {
                401: 'Unauthorized',
                500: 'Internal server error'
            }
        });
    }
    
}